module.exports = __webpack_public_path__ + "img/wh9.c2e2241d.png";